export const PERFORMANCE_PAGE_NS = 'pages/PerformancePage';

export const i18n = {
  en: {
    grid: {
      empty: 'You have no items yet',
    },
    dataExplorerReport: {
      title: 'Data Explorer',
    },
  },
};
